"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets = require("./widgets");
/**
 * A mime renderer factory for raw html.
 */
exports.htmlRendererFactory = {
    safe: true,
    mimeTypes: ['text/html'],
    defaultRank: 50,
    createRenderer: function (options) { return new widgets.RenderedHTML(options); }
};
/**
 * A mime renderer factory for images.
 */
exports.imageRendererFactory = {
    safe: true,
    mimeTypes: ['image/bmp', 'image/png', 'image/jpeg', 'image/gif'],
    defaultRank: 90,
    createRenderer: function (options) { return new widgets.RenderedImage(options); }
};
/**
 * A mime renderer factory for LaTeX.
 */
exports.latexRendererFactory = {
    safe: true,
    mimeTypes: ['text/latex'],
    defaultRank: 70,
    createRenderer: function (options) { return new widgets.RenderedLatex(options); }
};
/**
 * A mime renderer factory for Markdown.
 */
exports.markdownRendererFactory = {
    safe: true,
    mimeTypes: ['text/markdown'],
    defaultRank: 60,
    createRenderer: function (options) { return new widgets.RenderedMarkdown(options); }
};
/**
 * A mime renderer factory for svg.
 */
exports.svgRendererFactory = {
    safe: false,
    mimeTypes: ['image/svg+xml'],
    defaultRank: 80,
    createRenderer: function (options) { return new widgets.RenderedSVG(options); }
};
/**
 * A mime renderer factory for plain and jupyter console text data.
 */
exports.textRendererFactory = {
    safe: true,
    mimeTypes: ['text/plain', 'application/vnd.jupyter.stdout', 'application/vnd.jupyter.stderr'],
    defaultRank: 120,
    createRenderer: function (options) { return new widgets.RenderedText(options); }
};
/**
 * A placeholder factory for deprecated rendered JavaScript.
 */
exports.javaScriptRendererFactory = {
    safe: false,
    mimeTypes: ['text/javascript', 'application/javascript'],
    defaultRank: 110,
    createRenderer: function (options) { return new widgets.RenderedJavaScript(options); }
};
/**
 * The standard factories provided by the rendermime package.
 */
exports.standardRendererFactories = [
    exports.htmlRendererFactory,
    exports.markdownRendererFactory,
    exports.latexRendererFactory,
    exports.svgRendererFactory,
    exports.imageRendererFactory,
    exports.javaScriptRendererFactory,
    exports.textRendererFactory
];
